import { AppForm } from '../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ApplicantAppEntityApplicationRead, PaymentBaseAllBaseWritePaymentAllPaymentWrite } from '../../../openapi';

export interface PayerFormValue {
  payer: ApplicantAppEntityApplicationRead | null;
  serviceName: string | null;
  paymentTitle: string | null;
  totalAmount: string | null;
  decision: number;
}

@Injectable()
export class PayerForm extends AppForm {
  constructor() {
    super({
      payer: new FormControl(null, Validators.required),
      serviceName: new FormControl(null, Validators.required),
      paymentTitle: new FormControl(null, Validators.required),
      decision: new FormControl(null, Validators.required),
      totalAmount: new FormControl(null, Validators.required)
    });
  }

  public get paymentTitle(): FormControl {
    return this.get('paymentTitle') as FormControl;
  }

  public get serviceName(): FormControl {
    return this.get('serviceName') as FormControl;
  }

  public get payer(): FormControl {
    return this.get('payer') as FormControl;
  }

  public get totalAmount(): FormControl {
    return this.get('totalAmount') as FormControl;
  }

  public get decision(): FormControl {
    return this.get('decision') as FormControl;
  }

  public toWriteModel(): PaymentBaseAllBaseWritePaymentAllPaymentWrite {
    const v: PayerFormValue = this.value;
    return {
      clientEmail: v?.payer?.email || '',
      clientFirstName: v?.payer?.firstName || undefined,
      clientLastName: v?.payer?.lastName || undefined,
      clientName: v?.payer?.name || undefined,
      flatNumber: v?.payer?.apartmentNumber || undefined,
      street: v?.payer?.street || '',
      town: v?.payer?.city || '',
      streetNumber: v?.payer?.houseNumber || undefined,
      decision: v?.decision?.toString()
    };
  }
}
